export default "__VITE_ASSET__BwGRILps__"